import React from "react";
import MakroAlert, { MakroAlertType } from "../common/alert";
var CodeAlreadyUsed = function CodeAlreadyUsed() {
    return /*#__PURE__*/ React.createElement("div", {
        className: "content-text mt-4"
    }, /*#__PURE__*/ React.createElement(MakroAlert, {
        type: MakroAlertType.WARNING,
        title: "Code bereits genutzt",
        text: "Dieser Code wurde bereits eingel\xF6st."
    }));
};
export default CodeAlreadyUsed;
